export default function log(s) {
  console.info('[react-ga]', s);
}


//////////////////
// WEBPACK FOOTER
// ../~/react-ga/dist/esm/utils/console/log.js
// module id = 594
// module chunks = 7